<script>
    import "./startProject.css";
    import {defaultEvmStores, signerAddress} from 'svelte-ethers-store'
    import {metaMaskExtensionInstallationLink} from "../../../constants/constants";
    import {onMount} from "svelte";
    onMount(() => {
        window.scrollTo(0, 0);
    });
</script>
<div class="start-way-project">
    <div class="container">
        <h1 class="text-center">Start your Project With Polinate</h1>
        <p class="text-center">
            Are you a creator looking to get started but need access to some
            resources? Are you an established creator looking to create a VIP
            experience for your fans? Either way, Polinate is the right platform
            for you.
        </p>
        <div class="flex items-center flex-text-center main-project-way">
            <div class="project-heading">
                <h2>Kickstart your project</h2>
                <p>It's really as simple as setting things up in a few short
              steps and then launching it. So what's stopping you?
                </p>
                {#if $signerAddress}
                    <div class="flex items-center justify-center">
                        <a id="start-creation-page" href="#/permissionless" style="font-weight: 400;" class="flex items-center start-connect-btn btn-gradient-border">
                            Create Fixed Projects
                        </a>
                    </div>
                {:else}
                    <button id="start-connect-wallet" class="flex items-center start-connect-btn btn-gradient-border" on:click={() => {
                defaultEvmStores.setProvider().catch( () => {
                   setTimeout(
                        () =>
                          window.open(metaMaskExtensionInstallationLink, "_blank"),
                        1000
                   );
                })
            }}>
                        Connect Wallet
                        <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                        >
                            <path d="M6 6.75H0V5.25H6V0L12 6L6 12V6.75Z" fill="black" />
                        </svg>
                    </button>
                {/if}
            </div>
        </div>
    </div>
</div>